import { useAuth } from "@/contexts/AuthContext";
import { ROUTE } from "@/routes/constants";
import { UserInfoResponseRole } from "@/services/generatedAPIs.schemas";
import { useNavigate, Navigate } from "react-router";
import { useEffect, useState } from "react";

export default function HomePage() {
  const token = localStorage.getItem('token');
  const { tokenLogin } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(!!token);

  useEffect(() => {
    if (!token) {
      return;
    }

    let cancelled = false;

    tokenLogin()
      .then((user) => {
        if (cancelled) return;
        if (user) {
          if (user.role === UserInfoResponseRole.STUDENT) {
            navigate(ROUTE.STUDENT.OVERVIEW, { replace: true });
          } else if (user.role === UserInfoResponseRole.TEACHER) {
            navigate(ROUTE.TEACHER.OVERVIEW, { replace: true });
          }
        } else {
          localStorage.removeItem('token');
          navigate(ROUTE.LOGIN, { replace: true });
        }
      })
      .catch((error) => {
        if (cancelled) return;
        console.error("Error fetching user data:", error);
        localStorage.removeItem('token');
        navigate(ROUTE.LOGIN, { replace: true });
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token, tokenLogin, navigate]);

  if (!token) {
    return <Navigate to={ROUTE.LOGIN} />;
  }

  if (isLoading) {
    console.log("Loading user data...");
    return <div>Loading...</div>;
  }

  return null;
}
